<p-drawer [visible]="visible()" (onHide)="onDrawerHide()" position="right" styleClass="layout-config-sidebar w-80" header="Settings">
    <div class="flex flex-col gap-6">
        <div>
            <span class="text-lg text-muted-color font-semibold">Primary</span>
            <div class="pt-2 flex gap-2 flex-wrap">
                @for (primaryColor of primaryColors(); track primaryColor.name) {
                    <button
                        type="button"
                        [title]="primaryColor.name"
                        (click)="updateColors($event, 'primary', primaryColor)"
                        class="w-6 h-6 cursor-pointer hover:shadow-lg rounded duration-150 flex items-center justify-center"
                        [style]="{
                            'background-color': primaryColor?.name === 'noir' ? 'var(--text-color)' : primaryColor?.palette?.['500']
                        }"
                    >
                        <i *ngIf="primaryColor.name === selectedPrimaryColor()" class="pi pi-check text-white"></i>
                    </button>
                }
            </div>
        </div>

        <div>
            <span class="text-lg text-muted-color font-semibold">Surface</span>
            <div class="pt-2 flex gap-2 flex-wrap">
                @for (surface of surfaces; track surface.name) {
                    <button
                        type="button"
                        [title]="surface.name"
                        (click)="updateColors($event, 'surface', surface)"
                        class="w-6 h-6 cursor-pointer hover:shadow-lg rounded duration-150 flex items-center justify-center"
                        [style]="{
                            'background-color': surfaceSwatchColor(surface?.palette)
                        }"
                    >
                        <i *ngIf="selectedSurfaceColor() ? selectedSurfaceColor() === surface.name : darkTheme() ? surface.name === 'zinc' : surface.name === 'slate'" class="pi pi-check text-white"></i>
                    </button>
                }
            </div>
        </div>
        <div>
            <div class="flex flex-col gap-2">
                <span class="text-lg text-muted-color font-semibold">Presets</span>
                <p-selectbutton [options]="presets" [ngModel]="selectedPreset()" (ngModelChange)="onPresetChange($event)" [allowEmpty]="false"></p-selectbutton>
            </div>
        </div>
        <div>
            <div class="flex flex-col gap-2">
                <span class="text-lg text-muted-color font-semibold">Color Scheme</span>
                <p-selectbutton [ngModel]="darkTheme()" (ngModelChange)="toggleDarkMode()" [options]="themeOptions" optionLabel="name" optionValue="value" [allowEmpty]="false"></p-selectbutton>
            </div>
        </div>
        <div *ngIf="!simple && location === 'app'" class="flex flex-col gap-2">
            <span class="text-lg text-muted-color font-semibold">Card Style</span>
            <p-selectbutton [ngModel]="cardStyle()" (ngModelChange)="onCardStyleChange($event)" [options]="cardStyleOptions" optionLabel="name" optionValue="value" [allowEmpty]="false" />
        </div>

        <div *ngIf="!simple && location === 'app'" class="flex flex-col gap-2">
            <span class="text-lg text-muted-color font-semibold">Menu Theme</span>
            <p-selectbutton [ngModel]="menuTheme()" (ngModelChange)="onMenuThemeChange($event)" [options]="menuThemeOptions" optionLabel="name" optionValue="value" [allowEmpty]="false" />
        </div>

        <div *ngIf="!simple && location === 'app'">
            <div class="flex flex-col gap-2">
                <span class="text-lg text-muted-color font-semibold">Menu Type</span>
                <div class="flex flex-wrap flex-col gap-3">
                    <div class="flex">
                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="static" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('static')" inputId="static"></p-radiobutton>
                            <label for="static">Static</label>
                        </div>

                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="overlay" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('overlay')" inputId="overlay"></p-radiobutton>
                            <label for="overlay">Overlay</label>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="slim" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('slim')" inputId="slim"></p-radiobutton>
                            <label for="slim">Slim</label>
                        </div>
                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="compact" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('compact')" inputId="compact"></p-radiobutton>
                            <label for="compact">Compact</label>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="reveal" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('reveal')" inputId="reveal"></p-radiobutton>
                            <label for="reveal">Reveal</label>
                        </div>
                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="drawer" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('drawer')" inputId="drawer"></p-radiobutton>
                            <label for="drawer">Drawer</label>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex items-center gap-2 w-6/12">
                            <p-radiobutton name="menuMode" value="horizontal" [ngModel]="menuMode()" (ngModelChange)="setMenuMode('horizontal')" inputId="horizontal"></p-radiobutton>
                            <label for="horizontal">Horizontal</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-drawer>
